export default __webpack_public_path__ + "static/media/cart.fd2f7fd1.svg";